//------------- REACT IMPORT ---------------//
import React, { useEffect, useState } from "react";
//---------- FONTAWESOME IMPORT ------------//
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faAngleDown,
    faBed,
    faCalendarWeek,
    faHospital,
    faHouse,
    faImage,
    faVenus,
} from "@fortawesome/free-solid-svg-icons";
//-------- BOOTSTRAP ITEMS IMPORT ----------//
import { Button, Col, Container, Dropdown, Form, Image, Row } from "react-bootstrap";
import WithoutImageHeader from "../../../../Helper/withoutImageHeader";
//------------ CONSTANTS IMPORT ------------//
import * as Constants from "../../../../Helper/constants/constants";
import { Hospital_Img } from "../../../../../assets/images";
import FiltersHeader from "../../../../Helper/filtersHeader";
import AddHospitalFunctions from "./funstions";
import ButtonLoader from "../../../../Helper/buttonLoader";


const AddHospital = () => {
    const {
        handleChange,
        handleSubmit,
        values,
        isError,
        getHospitalDetail,
        breadcrumData,
        breadcrumItem,
        setBreadcrumItem,
        getCitiesList,
        getStatesList,
        citieslist,
        statesList,
        loaction,
        navigate,
        loader,
    } = AddHospitalFunctions();


    useEffect(() => {
        if (loaction && loaction.state && loaction.state.name) {
            let id = loaction && loaction.state && loaction.state.id ? loaction.state.id : ''
            getHospitalDetail(id);
            setBreadcrumItem('Edit Hospital');
        }
        else {
            setBreadcrumItem('Add Hospital');
        }
        getCitiesList();
        getStatesList();
    }, []);


    return (
        <div className="add_hospital_area">
            <WithoutImageHeader
                header={loaction && loaction.state && loaction.state.name ? Constants.EDIT_HOSPITAL : Constants.ADD_HOSPITAL}
                breadcrumData={breadcrumData}
                breadcrumItem={breadcrumItem}
                handleBack={() => navigate(-1)}
            />
            {/* <Container> */}
            <div className="hospital_content_area">
                <div className="img_icon_area">
                    <div className="img_area">
                        <Image src={Hospital_Img} alt="..." />
                    </div>
                    <div className="icon_area">
                        <FontAwesomeIcon icon={faImage} />
                    </div>
                </div>
                <div className="form_section">
                    <Row>
                        <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                            <Form>
                                <Form.Group className="form-group">
                                    <Form.Label>Hospital Name<span>*</span></Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="Oxford Hospital"
                                        autoCapitalize={true}
                                        value={values.name}
                                        className={isError.name.message
                                            ? "error_border"
                                            : ""}
                                        onChange={(e) =>
                                            handleChange(
                                                "name",
                                                e.target.value
                                            )
                                        }
                                    />
                                    {isError.name.message ? (
                                        <p className="text-danger mt-2">
                                            {isError.name.message}
                                        </p>
                                    ) : null}
                                </Form.Group>
                                <Form.Group className="form-group">
                                    <Form.Label>GSTIN<span>*</span></Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="9530NL"
                                        value={values.gstNumber}
                                        maxLength={15}
                                        className={isError.gstNumber.message
                                            ? "error_border"
                                            : ""}
                                        onChange={(e) =>
                                            handleChange(
                                                "gstNumber",
                                                e.target.value
                                            )
                                        }
                                    />
                                    {isError.gstNumber.message ? (
                                        <p className="text-danger mt-2">
                                            {isError.gstNumber.message}
                                        </p>
                                    ) : null}
                                </Form.Group>
                                <Form.Group className="form-group">
                                    <Form.Label>Contact Number<span>*</span></Form.Label>
                                    <Form.Control
                                        type="number"
                                        placeholder="+91-898-898-8989"
                                        value={values.phonenumber}
                                        maxLength={10}
                                        autoComplete="none"
                                        className={isError.phonenumber.message
                                            ? "error_border"
                                            : ""}
                                        onChange={(e) =>
                                            handleChange(
                                                "phonenumber",
                                                e.target.value
                                            )
                                        }
                                    />
                                    {isError.phonenumber.message ? (
                                        <p className="text-danger mt-2">
                                            {isError.phonenumber.message}
                                        </p>
                                    ) : null}
                                </Form.Group>
                                <Form.Group className="form-group">
                                    <Form.Label>Email ( Optional )</Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="robert@gmail.com"
                                        value={values.email}
                                        className={isError.email.message
                                            ? "error_border"
                                            : ""}
                                        onChange={(e) =>
                                            handleChange(
                                                "email",
                                                e.target.value
                                            )
                                        }
                                    />
                                    {isError.email.message ? (
                                        <p className="text-danger mt-2">
                                            {isError.email.message}
                                        </p>
                                    ) : null}
                                </Form.Group>
                                <Form.Group className="form-group">
                                    <Form.Label>Address<span>*</span></Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="Liwa Tower P.O. Box 901 Jalandhar"
                                        value={values.address}
                                        className={isError.address.message
                                            ? "error_border"
                                            : ""}
                                        onChange={(e) =>
                                            handleChange(
                                                "address",
                                                e.target.value
                                            )
                                        }
                                    />
                                    {isError.address.message ? (
                                        <p className="text-danger mt-2">
                                            {isError.address.message}
                                        </p>
                                    ) : null}
                                </Form.Group>
                            </Form>
                            <Row>
                                <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                                    <div className="dropdown_box">
                                        <h6>City<span>*</span></h6>
                                        <div className="dropdown_area">
                                            <Dropdown>
                                                <Dropdown.Toggle className={isError.city.message ? "error_border" : ""} id="dropdown-basic">
                                                    {values && values.city ? values.city : 'Select'}
                                                    <div className="icon down_icon ms-4">
                                                        <FontAwesomeIcon
                                                            icon={faAngleDown}
                                                        />
                                                    </div>
                                                </Dropdown.Toggle>
                                                <Dropdown.Menu>
                                                    {citieslist.map((item) => (
                                                        <Dropdown.Item onClick={() => handleChange("city", item.title)}>
                                                            {item.title}
                                                        </Dropdown.Item>
                                                    ))}
                                                </Dropdown.Menu>
                                            </Dropdown>
                                        </div>
                                        {isError.city.message ? (
                                            <p className="text-danger mt-2">
                                                {isError.city.message}
                                            </p>
                                        ) : null}
                                    </div>
                                </Col>
                                <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                                    <div className="dropdown_box">
                                        <h6>State<span>*</span></h6>
                                        <div className="dropdown_area">
                                            <Dropdown>
                                                <Dropdown.Toggle className={isError.state.message ? "error_border" : ""} id="dropdown-basic">
                                                    {values && values.state ? values.state : 'Select'}
                                                    <div className="icon down_icon ms-4">
                                                        <FontAwesomeIcon
                                                            icon={faAngleDown}
                                                        />
                                                    </div>
                                                </Dropdown.Toggle>
                                                <Dropdown.Menu>
                                                    {statesList.map((item) => (
                                                        <Dropdown.Item onClick={() => handleChange("state", item.title)}>
                                                            {item.title}
                                                        </Dropdown.Item>
                                                    ))}
                                                </Dropdown.Menu>
                                            </Dropdown>
                                        </div>
                                        {isError.state.message ? (
                                            <p className="text-danger mt-2">
                                                {isError.state.message}
                                            </p>
                                        ) : null}
                                    </div>
                                </Col>
                            </Row>
                            <Form>
                                <Form.Group className="form-group">
                                    <Form.Label>ZIP Code<span>*</span></Form.Label>
                                    <Form.Control
                                        type="number"
                                        placeholder="1410012"
                                        value={values.zipcode}
                                        maxLength={8}
                                        className={isError.zipcode.message
                                            ? "error_border"
                                            : ""}
                                        onChange={(e) =>
                                            handleChange(
                                                "zipcode",
                                                e.target.value
                                            )
                                        }
                                    />
                                    {isError.zipcode.message ? (
                                        <p className="text-danger mt-2">
                                            {isError.zipcode.message}
                                        </p>
                                    ) : null}
                                </Form.Group>
                                <Form.Group className="form-group">
                                    <Form.Label>Googel Map Link<span>*</span></Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="1410012"
                                        value={values.mapLink}
                                        className={isError.mapLink.message
                                            ? "error_border"
                                            : ""}
                                        onChange={(e) =>
                                            handleChange(
                                                "mapLink",
                                                e.target.value
                                            )
                                        }
                                    />
                                    {isError.mapLink.message ? (
                                        <p className="text-danger mt-2">
                                            {isError.mapLink.message}
                                        </p>
                                    ) : null}
                                </Form.Group>
                            </Form>
                            <div className="btn_area">
                                <Button
                                    className="cancelBtn"
                                    type="button"
                                    onClick={() => navigate(-1)}
                                >
                                    Cancel
                                </Button>
                                <Button
                                    className="submitBtn"
                                    type="button"
                                    onClick={() => handleSubmit()}
                                >
                                    {loader ? (
                                        <ButtonLoader
                                            loader={loader}
                                            variant={"light"}
                                        />
                                    ) : null}
                                    {loader ? "" : "Submit"}
                                </Button>
                            </div>
                        </Col>
                    </Row>
                </div>
            </div>
            {/* </Container> */}
        </div >
    );
};

export default AddHospital;
